import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap text-white [&>svg]:size-3 [&>svg]:pointer-events-none focus-visible:border-white/25 focus-visible:ring-white/15 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow,background-color]",
  {
    variants: {
      variant: {
        default:
          "border-white/10 bg-white/[0.1] text-white [a&]:hover:bg-white/[0.16]",
        secondary:
          "border-white/10 bg-white/[0.07] text-white/85 [a&]:hover:bg-white/[0.12]",
        destructive:
          "border-rose-400/20 bg-rose-500/18 text-white [a&]:hover:bg-rose-500/26 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline:
          "border-white/12 bg-white/[0.04] text-white/70 [a&]:hover:bg-white/[0.09] [a&]:hover:text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span"

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
